import React, { useRef, useEffect, useState } from "react";
import LoadingSpinner from "../components/LoadingSpinner";

interface EventOption {
  id: number;
  name: string;
  photo_count: number;
}

interface EventFilterDropdownProps {
  events: EventOption[];
  selectedEventIds: number[];
  onChange: (ids: number[], clickedId: number) => void;
  onClose: () => void;
  isLoading?: boolean;
  loadingItemId?: number | null;
}

const EventFilterDropdown: React.FC<EventFilterDropdownProps> = ({
  events,
  selectedEventIds,
  onChange,
  onClose,
  isLoading = false,
  loadingItemId = null
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as Node;

      if (ref.current?.contains(target)) return;

      if (target instanceof Element && target.closest(".mobile-filters-modal"))
        return;

      onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  const filtered = query.trim()
    ? events.filter(e => e.name.toLowerCase().includes(query.toLowerCase()))
    : events;

  const toggle = (id: number) => {
    const newIds = selectedEventIds.includes(id)
      ? selectedEventIds.filter(x => x !== id)
      : [...selectedEventIds, id];
    onChange(newIds, id);
  };

  return (
    <div
      className="search-filter-dropdown search-filter-dropdown--list"
      ref={ref}
    >
      <div className="search-filter-dropdown__search">
        <i className="fa fa-search search-filter-dropdown__search-icon"></i>
        <input
          type="text"
          className="search-filter-dropdown__search-input"
          placeholder="Search by event name"
          value={query}
          onChange={e => setQuery(e.target.value)}
          autoFocus
        />
      </div>
      <div className="search-filter-dropdown__list">
        {filtered.length === 0 ? (
          <div className="search-filter-dropdown__empty">No events found</div>
        ) : (
          <ul className="check-radio checkmark search-filter-dropdown__checkbox-list">
            {filtered.map(event => {
              const isSelected = selectedEventIds.includes(event.id);
              const isLoadingThis = isLoading && loadingItemId === event.id;
              return (
                <li key={event.id}>
                  <label>
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => toggle(event.id)}
                      disabled={isLoadingThis}
                    />
                    <span className="r-dot"></span>
                    <div className="search-filter-dropdown__item-content">
                      <span className="search-filter-dropdown__item-name">
                        {event.name}
                        {isLoadingThis && <LoadingSpinner />}
                      </span>
                      <span className="search-filter-dropdown__item-breadcrumb">
                        Library / {event.name}
                      </span>
                    </div>
                  </label>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default EventFilterDropdown;
